module.exports = __webpack_public_path__ + "img/example-healthcare-code-qr.cc5be021.jpg";